 import CustomStore from "devextreme/data/custom_store";

import { BaseEntitiesResponse, BaseEntity, BaseDataResponse, BaseResponse, BaseEntityResponse } from "../entities/BaseEntities";
import { FrameworkService } from "@core/framework/framework.service";
import { AppInjector } from "@core/injector/injector.module";
import { map, Observable } from 'rxjs';
 import {UiService} from '@core/framework/ui.service';


export abstract class BaseDataStoreAbstract
{
    protected m_store: CustomStore;
    public get Store(): CustomStore
    {
        return this.m_store;
    }

    //Convert the response we get from our webservice to what devexpress is expecting (array of objects)
    protected ShapeResponse(response: Observable<any>): any
    {
        return response.pipe(
            map((resultObject: any) =>
            {
                //Make sure result is success
                if (!(resultObject as BaseResponse).IsSuccess)
                {
                    AppInjector.get(UiService).UnexpectedMessage((resultObject as BaseResponse).ResponseMessage);
                    return [];
                }

                //Return the internal field
                if ((resultObject as BaseEntitiesResponse<BaseEntity>).Entities != undefined) return (resultObject as BaseEntitiesResponse<BaseEntity>).Entities;
                if ((resultObject as BaseDataResponse<any>).Data != undefined) return (resultObject as BaseDataResponse<any>).Data;
                if ((resultObject as BaseEntityResponse<BaseEntity>).Entity != undefined) return (resultObject as BaseEntityResponse<BaseEntity>).Entity;

                //If got here, something is wrong
                console.error(resultObject);
                console.error("Invalid response was returned");
                return [];
            })).toPromise();
    }     
}
